<div class="content" title="{{getLocaleText title}}">
	<i class="collapse-link icon-caret-right icon-large"></i>
	<i class="spinner icon-spinner icon-large"></i>
	<span class="page-tag {{tagClassName tag}}" style="background-color: {{getTagColor tag}}">{{{firstChar tag}}}</span>
	{{{getPageIcon class}}}
	<span>{{{getLocaleTextHTML title}}}</span>
</div>
<ul></ul>
